import React from 'react';
import NotificationCard from '../student/NotificationCard';
import EmptyState from '../ui/EmptyState';

// Real shape: GET /portal/announcements' own rows — { id, title, body, category, pinned, publish_at, expires_at,
// batch_id }. Announcements and notifications share ONE visual language (NotificationCard), so a placement update looks
// the same in the Placement Hub and in the Notification Center. The card is an announcement here, not an unread item, so
// no unread styling is applied (`plain`).
const CATEGORY = { general: 'general', assessment: 'assessment', placement_drive: 'placement', company: 'company', deadline: 'deadline' };

export const asNotification = (a) => ({
  id: `announcement:${a.id}`, type: 'announcement', category: CATEGORY[a.category] || 'general',
  title: a.title, body: a.body || '', created_at: a.publish_at, pinned: !!a.pinned, read: true,
});

export const AnnouncementCard = ({ announcement, expanded, onToggle }) => (
  <NotificationCard n={asNotification(announcement)} plain expanded={expanded} onToggle={onToggle} />
);

// Renders whatever real rows the caller passes in; shows an honest empty state otherwise, never fabricated notices.
export const PlacementHub = ({ announcements = [], title = 'Placement updates' }) => {
  const [openId, setOpenId] = React.useState(null);
  return (
    <div className="z-placement-hub">
      {title && <h3 className="z-section-title" style={{ marginBottom: 'var(--z-space-3)' }}>{title}</h3>}
      {announcements.length === 0 ? (
        <EmptyState icon="announcement" title="No placement updates yet" body="When your placement cell posts something, it will show up here." compact />
      ) : (
        <div className="z-placement-hub-list" style={{ display: 'flex', flexDirection: 'column', gap: 'var(--z-space-3)' }}>
          {announcements.map(a => <AnnouncementCard key={a.id} announcement={a} expanded={openId === a.id} onToggle={() => setOpenId(id => (id === a.id ? null : a.id))} />)}
        </div>
      )}
    </div>
  );
};
